import Vue from 'vue'
import xss from 'xss'

Object.defineProperty(Vue.prototype, '$xss', {
  value: source => {
    return xss(source, {
      whiteList: {
        a: ['href', 'target', 'download', 'type', 'style'],
        iframe: ['src', 'width', 'height', 'class', 'style', 'frameborder', 'allowfullscreen'],
        br: [],
        div: ['style'],
        p: ['style'],
        table: ['style', 'border', 'cellspacing', 'cellpadding'],
        tbody: [],
        thead: [],
        tr: [],
        td: ['style'],
        th: ['style'],
        ol: ['style'],
        ul: ['style'],
        li: ['style'],
        img: ['src', 'width', 'alt', 'style'],
        span: ['style'],
        h1: ['style'],
        h2: ['style'],
        h3: ['style'],
        h4: ['style'],
        h5: ['style'],
        h6: ['style'],
        strong: ['style'],
        i: ['style'],
        em: ['style'],
        b: ['style'],
        video: ['src', 'autoplay', 'controls', 'height', 'loop', 'muted', 'poster', 'preload', 'width'],
        audio: ['src', 'autoplay', 'controls', 'loop', 'muted', 'preload'],
        blockquote: [],
        pre: [],
        code: [],
        u: ['style']
      },
      stripIgnoreTag: true, // 过滤所有非白名单标签的HTML
      stripIgnoreTagBody: ['script', 'style']
    })
  }
})
